import React from 'react';
import PropTypes from 'prop-types';
import withCurrency from '../../../common/hoc/withCurrency';
import { formatAmount } from '../../../common/money';
import { EMPTY_PAYMENT_TYPE } from '../constants';

const formatBalance = (balance, currency) => (
  Number.isFinite(balance) ? `(Balance: ${formatAmount(balance, currency)})` : ''
);
const isOptionDisabled = (item, barber) => {
  return item.applicableToBarber && item.applicableToBarber !== barber.id;
};
const formatLabel = (item, currency) =>
  `${item.label} ${formatBalance(item.balance, currency)}`;

const appendDisabledMessage = (label, isDisabled) => {
  if (!isDisabled) {
    return label;
  }

  return `${label} not applicable to this barber`;
};

const SelectPayment = ({ payments, value, onChange, disabled, currency, currentBarber }) => (
  <select
    className="c-select u-mb"
    value={value}
    onChange={onChange}
    disabled={disabled}
  >
    <option value={EMPTY_PAYMENT_TYPE} disabled>Select payment method</option>
    {payments.map(item => (
      <option value={item.id} key={item.id} disabled={isOptionDisabled(item, currentBarber)}>
        {appendDisabledMessage(formatLabel(item, currency), isOptionDisabled(item, currentBarber))}
      </option>
    ))}
  </select>
);
SelectPayment.propTypes = {
  payments: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    applicableToBarber: PropTypes.string,
  })).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  currency: PropTypes.string.isRequired,
  currentBarber: PropTypes.shape({
    barberId: PropTypes.string,
  }).isRequired,
};

export default withCurrency(SelectPayment);
